{
  "about.blocks": "Modererte servere",
  "about.contact": "Kontakt:",
  "about.default_locale": "Standard",
  "about.disclaimer": "Mastodon er gratis, åpen kildekode-programvare og et varemerke fra Mastodon gGmbH.",
  "about.domain_blocks.no_reason_available": "Årsak ikke tilgjengelig",
  "about.domain_blocks.preamble": "Mastodon lar deg normalt sett se innholdet fra og samhandle med brukere fra enhver annen server i fødiverset. Dette er unntakene som har blitt lagt inn på denne serveren.",
  "about.domain_blocks.silenced.explanation": "Du vil vanligvis ikke se profiler og innhold fra denne serveren, med mindre du eksplisitt søker dem opp eller velger å følge dem.",
  "about.domain_blocks.silenced.title": "Begrenset",
  "about.domain_blocks.suspended.explanation": "Ikke noe innhold fra denne serveren vil bli behandlet, lagret eller utvekslet. Det gjør det umulig å samhandle eller kommunisere med brukere fra denne serveren.",
  "about.domain_blocks.suspended.title": "Suspendert",
  "about.language_label": "Språk",
  "about.not_available": "Denne informasjonen er ikke gjort tilgjengelig på denne serveren.",
  "about.powered_by": "Desentralisert sosialt medie drevet av {mastodon}",
  "about.rules": "Regler for serveren",
  "account.account_note_header": "Personlig notat",
  "account.activity": "Aktivitet",
  "account.add_note": "Legg til et personlig notat",
  "account.add_or_remove_from_list": "Legg til eller fjern fra lister",
  "account.badges.admin": "Administrator",
  "account.badges.blocked": "Blokkert",
  "account.badges.bot": "Automatisert",
  "account.badges.domain_blocked": "Blokkert domene",
  "account.badges.group": "Gruppe",
  "account.badges.muted": "Dempet",
  "account.badges.muted_until": "Dempet til {until}",
  "account.block": "Blokker @{name}",
  "account.block_domain": "Blokker domenet {domain}",
  "account.block_short": "Blokker",
  "account.blocked": "Blokkert",
  "account.cancel_follow_request": "Avbryt følgeforespørselen",
  "account.copy": "Kopier lenke til profil",
  "account.direct": "Nevn @{name} privat",
  "account.disable_notifications": "Slutt å varsle meg når @{name} legger ut innlegg",
  "account.edit_note": "Rediger personlig notat",
  "account.edit_profile": "Rediger profil",
  "account.edit_profile_short": "Rediger",
  "account.enable_notifications": "Varsle meg når @{name} legger ut innlegg",
  "account.endorse": "Vis frem på profilen",
  "account.familiar_followers_many": "Fulgt av {name1}, {name2}, og {othersCount, plural, one {en annen du kjenner} other {# andre du kjenner}}",
  "account.familiar_followers_one": "Fulgt av {name1}",
  "account.familiar_followers_two": "Fulgt av {name1} og {name2}",
  "account.featured": "Utvalgt",
  "account.featured.accounts": "Profiler",
  "account.featured.collections": "Samlinger",
  "account.field_overflow": "Vis fullt innhold",
  "account.filters.all": "All aktivitet",
  "account.filters.boosts_toggle": "Vis fremhevinger",
  "account.filters.posts_boosts": "Innlegg og fremhevinger",
  "account.filters.posts_only": "Innlegg",
  "account.filters.posts_replies": "Innlegg og svar",
  "account.filters.replies_toggle": "Vis svar",
  "account.follow": "Følg",
  "account.follow_back": "Følg tilbake",
  "account.follow_back_short": "Følg tilbake",
  "account.follow_request_cancel": "Avbryt forespørsel",
  "account.follow_request_cancel_short": "Avbryt",
  "account.followers": "Følgere",
  "account.followers.empty": "Ingen følger denne brukeren ennå.",
  "account.followers_counter": "{count, plural, one {{counter} følger} other {{counter} følgere}}",
  "account.followers_you_know_counter": "{counter} du kjenner",
  "account.following": "Følger",
  "account.following_counter": "{count, plural, one {{counter} som følges} other {{counter} som følges}}",
  "account.follows.empty": "Denne brukeren følger ikke noen enda.",
  "account.follows_you": "Følger deg",
  "account.go_to_profile": "Gå til profil",
  "account.hide_reblogs": "Skjul fremhevinger fra @{name}",
  "account.in_memoriam": "Til minne om.",
  "account.joined_short": "Ble med",
  "account.languages": "Endre hvilke språk du abonnerer på",
  "account.link_verified_on": "Eierskap av denne lenken ble sjekket {date}",
  "account.locked_info": "Denne kontoens personvernstatus er satt til låst. Eieren vurderer manuelt hvem som kan følge dem.",
  "account.media": "Media",
  "account.mention": "Nevn @{name}",
  "account.menu.add_to_list": "Legg til i liste…",
  "account.menu.block": "Blokker kontor",
  "account.menu.block_domain": "Blokker {domain}",
  "account.menu.copied": "Kopierte kontolenke til utklippstavle",
  "account.menu.copy": "Kopier lenke",
  "account.menu.direct": "Nevn privat",
  "account.menu.hide_reblogs": "Skjul fremhevinger i tidslinje",
  "account.menu.mention": "Nevn",
  "account.menu.mute": "Demp konto",
  "account.menu.note.description": "Synlig bare for deg",
  "account.menu.open_original_page": "Se på {domain}",
  "account.menu.remove_follower": "Fjern følger",
  "account.menu.report": "Rapporter konto",
  "account.menu.share": "Del…",
  "account.menu.show_reblogs": "Vis fremhevinger i tidslinje",
  "account.menu.unblock": "Opphev blokkering av konto",
  "account.menu.unblock_domain": "Opphev blokkering av {domain}",
  "account.menu.unmute": "Opphev demping av konto",
  "account.moved_to": "{name} har angitt at deres nye konto nå er:",
  "account.mute": "Demp @{name}",
  "account.mute_notifications_short": "Demp varsler",
  "account.mute_short": "Demp",
  "account.muted": "Dempet",
  "account.mutual": "Dere følger hverandre",
  "account.name.help.domain": "{domain} er serveren som inneholder profilen og innleggene for brukeren.",
  "account.name.help.domain_self": "{domain} er serveren som inneholder profilen og innleggene dine.",
  "account.name.help.header": "Et håndtak er som en e-postadresse",
  "account.name.help.username": "{username} er denne kontoens brukernavn på deres server. Noen på en annen server kan ha det samme brukernavnet.",
  "account.name.help.username_self": "{username} er ditt brukernavn på denne serveren. Noen på en annen server kan ha det samme brukernavnet.",
  "account.name_info": "Hva betyr dette?",
  "account.no_bio": "Ingen beskrivelse oppgitt.",
  "account.node_modal.callout": "Personlige notater er bare synlige for deg.",
  "account.node_modal.edit_title": "Rediger personlig notat",
  "account.node_modal.error_unknown": "Klarte ikke å lagre notatet",
  "account.node_modal.field_label": "Personlig notat",
  "account.node_modal.save": "Lagre",
  "account.node_modal.title": "Legg til et personlig notat",
  "account.note.edit_button": "Rediger",
  "account.note.title": "Personlig notat (bare synlig for deg)",
  "account.open_original_page": "Gå til originalsiden",
  "account.posts": "Innlegg",
  "account.remove_from_followers": "Fjern {name} fra følgere",
  "account.report": "Rapporter @{name}",
  "account.requested_follow": "{name} har bedt om å få følge deg",
  "account.share": "Del @{name} sin profil",
  "account.show_reblogs": "Vis fremhevinger fra @{name}",
  "account.statuses_counter": "{count, plural, one {{counter} innlegg} other {{counter} innlegg}}",
  "account.timeline.pinned": "Festet",
  "account.timeline.pinned.view_all": "Vis alle festede innlegg",
  "account.unblock": "Opphev blokkering av @{name}",
  "account.unblock_domain": "Opphev blokkering av {domain}",
  "account.unblock_domain_short": "Opphev blokkering",
  "account.unblock_short": "Opphev blokkering",
  "account.unendorse": "Ikke vis frem på profilen",
  "account.unfollow": "Slutt å følge",
  "account.unmute": "Opphev demping av @{name}",
  "account.unmute_notifications_short": "Opphev demping av varsler",
  "account.unmute_short": "Opphev demping",
  "account_edit.bio.placeholder": "Legg til en kort introduksjon for å hjelpe andre med å identifisere deg.",
  "account_edit.column_button": "Ferdig",
  "account_edit.column_title": "Rediger profil",
  "account_edit.custom_fields.reorder_button": "Omorganiser felter",
  "account_edit.custom_fields.tip_content": "Du kan enkelt øke troverdighet til Mastodon-kontoen din ved å verifisere koblinger til nettsider du eier.",
  "account_edit.custom_fields.tip_title": "Legg til bekreftede lenker",
  "account_edit.custom_fields.title": "Egendefinerte felter",
  "account_edit.custom_fields.verified_hint": "Hvordan legger jeg til en verifisert lenke?",
  "account_edit.save": "Lagre",
  "account_note.placeholder": "Klikk for å legge til et notat",
  "admin.dashboard.daily_retention": "Andel brukere som er aktive, per dag etter registrering",
  "admin.dashboard.monthly_retention": "Andel brukere som er aktive, per måned etter registrering",
  "admin.dashboard.retention.average": "Gjennomsnitt",
  "admin.dashboard.retention.cohort": "Registreringsmåned",
  "admin.dashboard.retention.cohort_size": "Nye brukere",
  "admin.impact_report.instance_accounts": "Kontoprofiler dette ville slettet",
  "admin.impact_report.instance_followers": "Følgere våre brukere ville mistet",
  "admin.impact_report.instance_follows": "Følgere deres brukere ville mistet",
  "admin.impact_report.title": "Sammendrag av konsekvensene",
  "alert.rate_limited.message": "Vennligst prøv igjen etter kl. {retry_time, time, medium}.",
  "alert.rate_limited.title": "Hastighetsbegrenset",
  "alert.unexpected.message": "En uventet feil oppstod.",
  "alert.unexpected.title": "Ups!",
  "alt_text_badge.title": "Alternativ tekst",
  "alt_text_modal.add_alt_text": "Legg til alternativ tekst",
  "alt_text_modal.add_text_from_image": "Legg til tekst fra bildet",
  "alt_text_modal.cancel": "Avbryt",
  "alt_text_modal.change_thumbnail": "Endre miniatyrbilde",
  "alt_text_modal.describe_for_people_with_hearing_impairments": "Beskriv dette for folk med hørselsproblemer…",
  "alt_text_modal.describe_for_people_with_visual_impairments": "Beskriv dette for folk med synsproblemer…",
  "alt_text_modal.done": "Ferdig",
  "announcement.announcement": "Kunngjøring",
  "annual_report.announcement.action_build": "Lag min Wrapstodon",
  "annual_report.announcement.action_dismiss": "Nei takk",
  "annual_report.announcement.action_view": "Se Wrapstodon",
  "annual_report.summary.close": "Lukk",
  "annual_report.summary.copy_link": "Kopier lenke",
  "annual_report.summary.most_used_app.most_used_app": "mest brukte applikasjoner",
  "annual_report.summary.most_used_hashtag.most_used_hashtag": "mest brukte evne knagg",
  "annual_report.summary.new_posts.new_posts": "nye innlegg",
  "annual_report.summary.percentile.text": "<topLabel>Det gjør at du er i topp</topLabel><percentage></percentage><bottomLabel>av brukere på {domain}.</bottomLabel>",
  "annual_report.summary.percentile.we_wont_tell_bernie": "Vi skal ikke si noe til Bernie.",
  "attachments_list.unprocessed": "(ubehandlet)",
  "audio.hide": "Skjul lyd",
  "block_modal.remote_users_caveat": "Vi vil be serveren {domain} om å respektere din beslutning. Det er imidlertid ingen garanti at det blir overholdt, siden noen servere kan håndtere blokkeringer på forskjellig vis. Offentlige innlegg kan fortsatt være synlige for ikke-innloggede brukere.",
  "block_modal.show_less": "Vis mindre",
  "block_modal.show_more": "Vis mer",
  "block_modal.they_will_know": "De kan se at de er blitt blokkert.",
  "block_modal.title": "Blokker bruker?",
  "boost_modal.combo": "You kan trykke {combo} for å hoppe over dette neste gang",
  "boost_modal.reblog": "Fremhev innlegg?",
  "boost_modal.undo_reblog": "Fjern fremheving?",
  "bundle_column_error.copy_stacktrace": "Kopier feilrapport",
  "bundle_column_error.error.body": "Den forespurte siden kan ikke gjengis. Den kan skyldes en feil i vår kode eller et kompatibilitetsproblem med nettleseren.",
  "bundle_column_error.error.title": "Å nei!",
  "bundle_column_error.network.body": "Det oppsto en feil under forsøk på å laste inn denne siden. Dette kan skyldes et midlertidig problem med din internettilkobling eller denne serveren.",
  "bundle_column_error.network.title": "Nettverksfeil",
  "bundle_column_error.retry": "Prøv igjen",
  "bundle_column_error.return": "Gå hjem igjen",
  "bundle_column_error.routing.body": "Den forespurte siden ble ikke funnet. Er du sikker på at URL-en i adresselinjen er riktig?",
  "bundle_column_error.routing.title": "404",
  "bundle_modal_error.close": "Lukk",
  "bundle_modal_error.message": "Noe gikk galt mens denne komponenten ble lastet inn.",
  "bundle_modal_error.retry": "Prøv igjen",
  "carousel.current": "<sr>Side</sr> {current, number} / {max, number}",
  "carousel.slide": "Side {current, number} av {max, number}",
  "character_counter.recommended": "{currentLength}/{maxLength} anbefalte tegn",
  "character_counter.required": "{currentLength}/{maxLength} tegn",
  "closed_registrations.other_server_instructions": "Siden Mastodon er desentralizert, kan du opprette en konto på en annen server og fortsatt kommunisere med denne.",
  "closed_registrations_modal.description": "Opprettelse av en konto på {domain} er for tiden ikke mulig, men vær oppmerksom på at du ikke trenger en konto spesifikt på {domain} for å kunne bruke Mastodon.",
  "closed_registrations_modal.find_another_server": "Finn en annen server",
  "closed_registrations_modal.preamble": "Mastodon er desentralisert, så uansett hvor du oppretter kontoen din, vil du kunne følge og samhandle med alle på denne serveren. Du kan til og med kjøre serveren selv!",
  "closed_registrations_modal.title": "Registrerer deg på Mastodon",
  "collection.share_modal.share_via_post": "Publiser på Mastodon",
  "collection.share_modal.share_via_system": "Del med…",
  "collection.share_modal.title": "Del samling",
  "collection.share_modal.title_new": "Del din nye samling!",
  "column.about": "Om",
  "column.blocks": "Blokkerte brukere",
  "column.bookmarks": "Bokmerker",
  "column.community": "Lokal tidslinje",
  "column.create_list": "Opprett liste",
  "column.direct": "Private omtaler",
  "column.directory": "Bla gjennom profiler",
  "column.domain_blocks": "Skjulte domener",
  "column.edit_list": "Rediger listen",
  "column.favourites": "Favoritter",
  "column.firehose": "Tidslinjer",
  "column.follow_requests": "Følgeforespørsler",
  "column.home": "Hjem",
  "column.list_members": "Administrer listemedlemmer",
  "column.lists": "Lister",
  "column.mutes": "Dempede brukere",
  "column.notifications": "Varsler",
  "column.pins": "Festede innlegg",
  "column.public": "Felles tidslinje",
  "column_back_button.label": "Tilbake",
  "column_header.hide_settings": "Skjul innstillinger",
  "column_header.moveLeft_settings": "Flytt feltet til venstre",
  "column_header.moveRight_settings": "Flytt feltet til høyre",
  "column_header.pin": "Fest",
  "column_header.show_settings": "Vis innstillinger",
  "column_header.unpin": "Løsne",
  "column_search.cancel": "Avbryt",
  "community.column_settings.local_only": "Kun lokalt",
  "community.column_settings.media_only": "Media only",
  "community.column_settings.remote_only": "Kun eksternt",
  "compose.language.change": "Bytt språk",
  "compose.language.search": "Søk etter språk...",
  "compose.published.body": "Innlegg publisert.",
  "compose.published.open": "Åpne",
  "compose.saved.body": "Innlegg lagret.",
  "compose_form.direct_message_warning_learn_more": "Lær mer",
  "compose_form.encryption_warning": "Innlegg på Mastodon er ikke ende-til-ende-krypterte. Ikke del sensitive opplysninger via Mastodon.",
  "compose_form.hashtag_warning": "Dette innlegget blir ikke vist under noen emneknagger siden det ikke er offentlig. Bare offentlige innlegg kan søkes opp med emneknagger.",
  "compose_form.lock_disclaimer": "Din konto er ikke {locked}. Hvem som helst kan følge deg og se dine private poster.",
  "compose_form.lock_disclaimer.lock": "låst",
  "compose_form.placeholder": "Hva har du på hjertet?",
  "compose_form.poll.duration": "Avstemningens varighet",
  "compose_form.poll.multiple": "Flervalg",
  "compose_form.poll.option_placeholder": "Valg {number}",
  "compose_form.poll.single": "Enkelt valg",
  "compose_form.poll.switch_to_multiple": "Endre avstemning til å tillate flere valg",
  "compose_form.poll.switch_to_single": "Endre avstemning til å tillate ett valg",
  "compose_form.poll.type": "Stil",
  "compose_form.publish": "Publiser",
  "compose_form.reply": "Svar",
  "compose_form.save_changes": "Oppdater",
  "compose_form.spoiler.marked": "Fjern innholdsvarsel",
  "compose_form.spoiler.unmarked": "Legg til innholdsvarsel",
  "compose_form.spoiler_placeholder": "Innholdsadvarsel (valgfritt)",
  "confirmation_modal.cancel": "Avbryt",
  "confirmations.block.confirm": "Blokkèr",
  "confirmations.delete.confirm": "Slett",
  "confirmations.delete.message": "Er du sikker på at du vil slette dette innlegget?",
  "confirmations.delete.title": "Slett innlegg?",
  "confirmations.delete_list.confirm": "Slett",
  "confirmations.delete_list.message": "Er du sikker på at du vil slette denne listen permanent?",
  "confirmations.delete_list.title": "Slett liste?",
  "confirmations.discard_edit_media.confirm": "Forkast",
  "confirmations.discard_edit_media.message": "Du har ulagrede endringer i mediebeskrivelsen eller i forhåndsvisning, forkast dem likevel?",
  "confirmations.follow_to_list.confirm": "Følg og legg til i liste",
  "confirmations.follow_to_list.message": "Du må følge {name} for å kunne legge vedkommende til i en liste.",
  "confirmations.follow_to_list.title": "Følg bruker?",
  "confirmations.logout.confirm": "Logg ut",
  "confirmations.logout.message": "Er du sikker på at du vil logge ut?",
  "confirmations.logout.title": "Logg ut?",
  "confirmations.missing_alt_text.confirm": "Legg til bildebeskrivelse",
  "confirmations.missing_alt_text.message": "Innlegget ditt mangler bildebeskrivelse. Legg til en tekst for å gjøre innholdet ditt tilgjengelig for flere brukere.",
  "confirmations.missing_alt_text.secondary": "Legg ut likevel",
  "confirmations.missing_alt_text.title": "Legg til bildebeskrivelse?",
  "confirmations.mute.confirm": "Demp",
  "confirmations.private_quote_notify.cancel": "Tilbake til redigering",
  "confirmations.private_quote_notify.confirm": "Publiser innlegg",
  "confirmations.private_quote_notify.do_not_show_again": "Ikke vis meg denne meldingen igjen",
  "confirmations.private_quote_notify.message": "Personen du siterer og andre som er nevnt vil bli varslet og vil kunne se innlegget ditt, selv om de ikke følger deg.",
  "confirmations.private_quote_notify.title": "Del med følgere og nevnte brukere?",
  "confirmations.quiet_post_quote_info.got_it": "Forstått",
  "confirmations.redraft.confirm": "Slett og skriv på nytt",
  "confirmations.redraft.message": "Er du sikker på at du vil slette dette innlegget og lagre det på nytt? Favoritter og fremhevinger vil gå tapt, og svar til det originale innlegget vil bli foreldreløse.",
  "confirmations.redraft.title": "Slett og skriv på nytt?",
  "confirmations.remove_from_followers.confirm": "Fjern følger",
  "confirmations.remove_from_followers.message": "{name} vil ikke lenger følge deg. Er du sikker på at du vil fortsette?",
  "confirmations.remove_from_followers.title": "Fjern følger?",
  "confirmations.revoke_collection_inclusion.confirm": "Fjern meg",
  "confirmations.revoke_collection_inclusion.title": "Fjern deg selv fra denne samlingen?",
  "confirmations.revoke_quote.confirm": "Fjern innlegg",
  "confirmations.revoke_quote.message": "Denne handlingen kan ikke angres.",
  "confirmations.revoke_quote.title": "Fjern innlegg?",
  "confirmations.unblock.confirm": "Opphev blokkering",
  "confirmations.unblock.title": "Opphev blokkering av {name}?",
  "confirmations.unfollow.confirm": "Slutt å følge",
  "confirmations.unfollow.title": "Slutt å følge {name}?",
  "confirmations.withdraw_request.confirm": "Trekk tilbake forespørsel",
  "confirmations.withdraw_request.title": "Trekk tilbake forespørsel om å følge {name}?",
  "content_warning.hide": "Skjul innlegg",
  "content_warning.show": "Vis likevel",
  "content_warning.show_more": "Vis mer",
  "conversation.delete": "Slett samtalen",
  "conversation.mark_as_read": "Marker som lest",
  "conversation.open": "Vis samtale",
  "conversation.with": "Med {names}",
  "copy_icon_button.copied": "Kopiert til utklippstavlen",
  "copypaste.copied": "Kopiert",
  "copypaste.copy_to_clipboard": "Kopier til utklippstavle",
  "directory.federated": "Fra det kjente fødiverset",
  "directory.local": "Kun fra {domain}",
  "directory.new_arrivals": "Nye ankomster",
  "directory.recently_active": "Nylig aktiv",
  "disabled_account_banner.account_settings": "Kontoinnstillinger",
  "disabled_account_banner.text": "Din konto {disabledAccount} er for øyeblikket deaktivert.",
  "dismissable_banner.community_timeline": "Dette er de nyeste offentlige innleggene fra personer med kontoer på {domain}.",
  "dismissable_banner.dismiss": "Avvis",
  "dismissable_banner.public_timeline": "Dette er de nyeste offentlige innleggene fra folk brukerne av {domain} følger på det desentraliserte nettverket.",
  "domain_block_modal.block": "Blokker server",
  "domain_block_modal.block_account_instead": "Blokker @{name} i stedet",
  "domain_block_modal.they_can_interact_with_old_posts": "Personer fra denne serveren kan samhandle med dine gamle innlegg.",
  "domain_block_modal.they_cant_follow": "Ingen fra denne serveren kan følge deg.",
  "domain_block_modal.they_wont_know": "De kommer ikke til å få vite at du har valgt å blokkere dem.",
  "domain_block_modal.title": "Blokker domenet?",
  "domain_block_modal.you_will_lose_num_followers": "Du kommer til å miste {followersCount, plural, one {{followersCountDisplay} følger} other {{followersCountDisplay} følgere}} og {followingCount, plural, one {{followingCountDisplay} du følger} other {{followingCountDisplay} du følger}}.",
  "domain_block_modal.you_will_lose_relationships": "Du vil miste alle følgere og folk du følger fra denne serveren.",
  "domain_block_modal.you_wont_see_posts": "Du vil ikke se innlegg eller få varsler fra brukere på denne serveren.",
  "domain_pill.activitypub_lets_connect": "Den lar deg koble til og samhandle med folk ikke bare på Mastodon, men også på tvers av forskjellige sosiale apper.",
  "domain_pill.activitypub_like_language": "ActivityPub er liksom språket Mastodon snakker med andre sosiale nettverk.",
  "domain_pill.server": "Server",
  "domain_pill.their_handle": "Deres håndtak:",
  "domain_pill.their_server": "Deres digitale hjem, hvor alle innleggene deres bor.",
  "domain_pill.their_username": "Deres unike identifikator på serveren sin. Det er mulig å finne brukere med samme brukernavn på forskjellige servere.",
  "domain_pill.username": "Brukernavn",
  "domain_pill.whats_in_a_handle": "Hva er et håndtak?",
  "domain_pill.who_they_are": "Siden håndtakene sier hvem noen er og hvor de er, kan du samhandle med folk på tvers av det sosiale nettverket bestående av <button>plattformer som støtter ActivityPub</button>.",
  "domain_pill.who_you_are": "Fordi ditt håndtak sier hvem du er og hvor du er, kan folk kommunisere med deg på tvers av <button>plattformer som støtter ActivityPub</button>.",
  "domain_pill.your_handle": "Din håndtak:",
  "domain_pill.your_server": "Ditt digitale hjem, hvor alle dine innlegg bor. Liker du ikke denne? Flytt till en annen server når som helst og ta med følgerne dine.",
  "domain_pill.your_username": "Din unike identifikator på denne serveren. Det er mulig å finne brukere med samme brukernavn på forskjellige servere.",
  "embed.instructions": "Kopier koden under for å bygge inn denne statusen på hjemmesiden din.",
  "embed.preview": "Slik kommer det til å se ut:",
  "emoji_button.activity": "Aktivitet",
  "emoji_button.clear": "Nullstill",
  "emoji_button.custom": "Tilpasset",
  "emoji_button.flags": "Flagg",
  "emoji_button.food": "Mat og drikke",
  "emoji_button.label": "Sett inn emoji",
  "emoji_button.nature": "Natur",
  "emoji_button.not_found": "Ingen emojojoer!! (╯°□°）╯︵ ┻━┻",
  "emoji_button.objects": "Objekter",
  "emoji_button.people": "Mennesker",
  "emoji_button.recent": "Hyppig brukt",
  "emoji_button.search": "Søk...",
  "emoji_button.search_results": "Søkeresultat",
  "emoji_button.symbols": "Symboler",
  "emoji_button.travel": "Reise & steder",
  "empty_column.account_hides_collections": "Denne brukeren har valgt å ikke gjøre denne informasjonen tilgjengelig",
  "empty_column.account_suspended": "Kontoen er suspendert",
  "empty_column.account_timeline": "Ingen innlegg her!",
  "empty_column.account_unavailable": "Profilen er utilgjengelig",
  "empty_column.blocks": "Du har ikke blokkert noen brukere enda.",
  "empty_column.bookmarked_statuses": "Du har ikke noen bokmerkede innlegg enda. Når du har noen bokmerkede innlegg, vil de dukke opp her.",
  "empty_column.community": "Den lokale tidslinjen er tom. Skriv noe offentlig for å få snøballen til å rulle!",
  "empty_column.direct": "Du har ingen private omtaler enda. Etter du har sendt eller mottatt en, så vil den dukke opp her.",
  "empty_column.domain_blocks": "Det er ingen skjulte domener enda.",
  "empty_column.explore_statuses": "Ingenting er populært akkurat nå. Prøv igjen senere!",
  "empty_column.favourited_statuses": "Du har ikke noen favorittinnlegg enda. Når du favorittmarkerer et inlegg, vil det dukke opp her.",
  "empty_column.favourites": "Ingen har favorittmarkert dette innlegget ennå. Når noen gjør det, vil de dukke opp her.",
  "empty_column.follow_requests": "Du har ingen følgeforespørsler enda. Når du mottar en, vil den dukke opp her.",
  "empty_column.followed_tags": "Du har ikke fulgt noen emneknagger ennå. Når du gjør det, vil de vises her.",
  "empty_column.hashtag": "Det er ingenting i denne emneknaggen ennå.",
  "empty_column.home": "Hjem-tidslinjen din er tom! Følg flere folk for å fylle den. {suggestions}",
  "empty_column.list": "Det er ingenting i denne listen ennå. Når medlemmene av denne listen legger ut nye statuser vil de dukke opp her.",
  "empty_column.mutes": "Du har ikke dempet noen brukere enda.",
  "empty_column.notification_requests": "Alt klart! Det er ingenting her. Når du mottar nye varsler, vises de her i henhold til dine innstillinger.",
  "empty_column.notifications": "Du har ingen varsler ennå. Kommuniser med andre for å begynne samtalen.",
  "empty_column.public": "Det er ingenting her! Skriv noe offentlig, eller følg brukere manuelt fra andre instanser for å fylle den opp",
  "error.unexpected_crash.explanation": "På grunn av en bug i koden vår eller et nettleserkompatibilitetsproblem, kunne denne siden ikke vises riktig.",
  "error.unexpected_crash.explanation_addons": "Denne siden kunne ikke vises riktig. Denne feilen er sannsynligvis forårsaket av en nettleserutvidelse eller automatiske oversettelsesverktøy.",
  "error.unexpected_crash.next_steps": "Prøv å oppfriske siden. Dersom det ikke hjelper, vil du kanskje fortsatt kunne bruke Mastodon gjennom en annen nettleser eller app.",
  "error.unexpected_crash.next_steps_addons": "Prøv å deaktivere dem og laste siden på nytt. Hvis det ikke hjelper, kan du fremdeles bruke Mastodon via en annen nettleser eller en annen app.",
  "errors.unexpected_crash.copy_stacktrace": "Kopier stacktrace-en til utklippstavlen",
  "errors.unexpected_crash.report_issue": "Rapporter en feil",
  "explore.suggested_follows": "Personer",
  "explore.title": "Populært",
  "explore.trending_links": "Nyheter",
  "explore.trending_statuses": "Innlegg",
  "explore.trending_tags": "Emneknagger",
  "featured_carousel.header": "{count, plural, one {{counter} festet innlegg} other {{counter} festede innlegg}}",
  "filter_modal.added.context_mismatch_explanation": "Denne filterkategorien gjelder ikke for den konteksten du har åpnet dette innlegget i. Hvis du vil at innlegget skal filtreres i denne konteksten også, må du redigere filteret.",
  "filter_modal.added.context_mismatch_title": "Feil sammenheng!",
  "filter_modal.added.expired_explanation": "Denne filterkategorien er utløpt, du må endre utløpsdato for at den skal gjelde.",
  "filter_modal.added.expired_title": "Utløpt filter!",
  "filter_modal.added.review_and_configure": "For å gjennomgå og ytterligere konfigurere denne filterkategorien, gå til {settings_link}.",
  "filter_modal.added.review_and_configure_title": "Filterinnstillinger",
  "filter_modal.added.settings_link": "innstillinger-siden",
  "filter_modal.added.short_explanation": "Dette innlegget er lagt til i følgende filterkategori: {title}.",
  "filter_modal.added.title": "Filter lagt til!",
  "filter_modal.select_filter.context_mismatch": "gjelder ikke for denne sammenhengen",
  "filter_modal.select_filter.expired": "utløpt",
  "filter_modal.select_filter.prompt_new": "Ny kategori: {name}",
  "filter_modal.select_filter.search": "Søk eller opprett",
  "filter_modal.select_filter.subtitle": "Bruk en eksisterende kategori eller opprett en ny",
  "filter_modal.select_filter.title": "Filtrer dette innlegget",
  "filter_modal.title.status": "Filtrer et innlegg",
  "filter_warning.matches_filter": "Treff på filter \"<span>{title}</span>\"",
  "filtered_notifications_banner.pending_requests": "Fra {count, plural, =0 {ingen} one {en person} other {# folk}} du kanskje kjenner",
  "filtered_notifications_banner.title": "Filtrerte varsler",
  "firehose.all": "Alt",
  "firehose.local": "Denne serveren",
  "firehose.remote": "Andre servere",
  "follow_request.authorize": "Autoriser",
  "follow_request.reject": "Avvis",
  "follow_requests.unlocked_explanation": "Selv om kontoen din ikke er låst, tror {domain} ansatte at du kanskje vil gjennomgå forespørsler fra disse kontoene manuelt.",
  "follow_suggestions.curated_suggestion": "Utvalgt av staben",
  "follow_suggestions.dismiss": "Ikke vis igjen",
  "follow_suggestions.featured_longer": "Håndplukket av {domain}-teamet",
  "follow_suggestions.friends_of_friends_longer": "Populært blant personer du følger",
  "follow_suggestions.hints.featured": "Denne profilen er håndplukket av {domain}-teamet.",
  "follow_suggestions.hints.friends_of_friends": "Denne profilen er populær blant de du følger.",
  "follow_suggestions.hints.most_followed": "Denne profilen er en av de på {domain} som har flest følgere.",
  "follow_suggestions.hints.most_interactions": "Denne profilen fått mye oppmerksomhet i det siste på {domain}.",
  "follow_suggestions.hints.similar_to_recently_followed": "Denne profilen ligner på profilene du nylig har fulgt.",
  "follow_suggestions.personalized_suggestion": "Personlig forslag",
  "follow_suggestions.popular_suggestion": "Populært forslag",
  "follow_suggestions.popular_suggestion_longer": "Populært på {domain}",
  "follow_suggestions.similar_to_recently_followed_longer": "Likner på profiler du nylig har fulgt",
  "follow_suggestions.view_all": "Vis alle",
  "follow_suggestions.who_to_follow": "Hvem du kan følge",
  "followed_tags": "Fulgte emneknagger",
  "footer.about": "Om",
  "footer.directory": "Profilkatalog",
  "footer.get_app": "Last ned appen",
  "footer.keyboard_shortcuts": "Hurtigtaster",
  "footer.privacy_policy": "Personvernregler",
  "footer.source_code": "Vis kildekode",
  "footer.status": "Status",
  "footer.terms_of_service": "Bruksvilkår",
  "generic.saved": "Lagret",
  "getting_started.heading": "Kom i gang",
  "hashtag.admin_moderation": "Åpne modereringsgrensesnitt for #{name}",
  "hashtag.browse": "Utforsk poster i #{hashtag}",
  "hashtag.browse_from_account": "Utforsk poster av @{name} i #{hashtag}",
  "hashtag.column_header.tag_mode.all": "og {additional}",
  "hashtag.column_header.tag_mode.any": "eller {additional}",
  "hashtag.column_header.tag_mode.none": "uten {additional}",
  "hashtag.column_settings.select.no_options_message": "Ingen forslag ble funnet",
  "hashtag.column_settings.select.placeholder": "Skriv inn emneknagger…",
  "hashtag.column_settings.tag_mode.all": "Alle disse",
  "hashtag.column_settings.tag_mode.any": "Enhver av disse",
  "hashtag.column_settings.tag_mode.none": "Ingen av disse",
  "hashtag.column_settings.tag_toggle": "Include additional tags in this column",
  "hashtag.counter_by_accounts": "{count, plural, one {{counter} deltaker} other {{counter} deltakere}}",
  "hashtag.counter_by_uses": "{count, plural, one {ett innlegg} other {{counter} innlegg}}",
  "hashtag.counter_by_uses_today": "{count, plural, one {ett innlegg} other {{counter} innlegg}} i dag",
  "hashtag.feature": "Fremhev på din profil",
  "hashtag.follow": "Følg emneknagg",
  "hashtag.mute": "Demp #{hashtag}",
  "hashtag.unfeature": "Ikke fremhev på din profil",
  "hashtag.unfollow": "Slutt å følge emneknagg",
  "hashtags.and_other": "…og {count, plural, one{en til} other {# til}}",
  "hints.profiles.followers_may_be_missing": "Følgere for denne profilen mangler kanskje.",
  "hints.profiles.follows_may_be_missing": "Hvem denne profilen følger mangler kanskje.",
  "hints.profiles.posts_may_be_missing": "Det kan hende at noen av innleggene til denne profilen mangler.",
  "hints.profiles.see_more_followers": "Se flere følgere på {domain}",
  "hints.profiles.see_more_follows": "Se flere som følger på {domain}",
  "hints.profiles.see_more_posts": "Se flere innlegg på {domain}",
  "home.column_settings.show_quotes": "Vis sitater",
  "home.column_settings.show_reblogs": "Vis fremhevinger",
  "home.column_settings.show_replies": "Vis svar",
  "home.hide_announcements": "Skjul kunngjøring",
  "home.pending_critical_update.body": "Vennligst oppdater Mastodon-serveren din så snart som mulig!",
  "home.pending_critical_update.link": "Se oppdateringer",
  "home.pending_critical_update.title": "Kritisk sikkerhetsoppdatering er tilgjengelig!",
  "home.show_announcements": "Vis kunngjøring",
  "ignore_notifications_modal.disclaimer": "Mastodon kan ikke informere brukere at du har ignorert deres varsler. Å ignorere varsler vil ikke stoppe meldinger selv fra å bli sendt.",
  "ignore_notifications_modal.filter_instead": "Filtrer i stedet",
  "ignore_notifications_modal.filter_to_act_users": "Du kan fremdeles akseptere, avvise eller rapportere brukere",
  "ignore_notifications_modal.filter_to_avoid_confusion": "Filtrering bidrar til å unngå potensiell forvirring",
  "ignore_notifications_modal.filter_to_review_separately": "Du kan gjennomgå filtrerte varsler for seg",
  "ignore_notifications_modal.ignore": "Overse varsler",
  "ignore_notifications_modal.limited_accounts_title": "Overse varsler fra modererte kontoer?",
  "ignore_notifications_modal.new_accounts_title": "Overse varsler fra nye kontoer?",
  "ignore_notifications_modal.not_followers_title": "Overse varsler fra folk som ikke følger deg?",
  "ignore_notifications_modal.not_following_title": "Overse varsler fra folk du ikke følger?",
  "ignore_notifications_modal.private_mentions_title": "Overse varsler fra uoppfordrede private omtaler?",
  "info_button.label": "Hjelp",
  "info_button.what_is_alt_text": "<h1>Hva er alternativ tekst?</h1> <p>Alternativ tekst gir en bildebeskrivelse til folk med nedsatt syn, lav båndbredde eller de som vil ha mer kontekst.</p> <p>Du kan forbedre tilgjengeligheten og forståelsen for alle ved å skive en tydelig, konsis og objektiv alternativ tekst.</p> <ul> <li>Få med deg viktige elementer</li> <li>Summér tekst i bilder</li> <li>Bruk vanlige setningsstrukturer</li> <li>Unngå overflødig informasjon</li> <li>Fokuser på trender og viktige funn i komplekse grafiske fremstillinger (som diagram og kart)</li> </ul>",
  "interaction_modal.go": "Gå",
  "interaction_modal.no_account_yet": "Har du ikke en konto ennå?",
  "interaction_modal.on_another_server": "På en annen server",
  "interaction_modal.on_this_server": "På denne serveren",
  "interaction_modal.username_prompt": "For eksempel {example}",
  "intervals.full.days": "{number, plural,one {# dag} other {# dager}}",
  "intervals.full.hours": "{number, plural, one {# time} other {# timer}}",
  "intervals.full.minutes": "{number, plural, one {# minutt} other {# minutter}}",
  "keyboard_shortcuts.back": "Gå tilbake",
  "keyboard_shortcuts.blocked": "Åpne listen over blokkerte brukere",
  "keyboard_shortcuts.boost": "Fremhev innlegg",
  "keyboard_shortcuts.column": "Gå til en kolonne",
  "keyboard_shortcuts.compose": "Gå til komponeringsfeltet",
  "keyboard_shortcuts.description": "Beskrivelse",
  "keyboard_shortcuts.down": "Flytt nedover i listen",
  "keyboard_shortcuts.enter": "Åpne innlegg",
  "keyboard_shortcuts.favourite": "Favorittmarker innlegg",
  "keyboard_shortcuts.favourites": "Åpne listen over favoritter",
  "keyboard_shortcuts.federated": "Åpne fellestidslinjen",
  "keyboard_shortcuts.heading": "Hurtigtaster",
  "keyboard_shortcuts.home": "Åpne hjemmetidslinjen",
  "keyboard_shortcuts.hotkey": "Lyntast",
  "keyboard_shortcuts.legend": "Vis denne tegnforklaringen",
  "keyboard_shortcuts.local": "Åpne den lokale tidslinjen",
  "keyboard_shortcuts.mention": "Nevn forfatter",
  "keyboard_shortcuts.muted": "Åpne listen over dempede brukere",
  "keyboard_shortcuts.my_profile": "Åpne profilen din",
  "keyboard_shortcuts.notifications": "Åpne varslingskolonnen",
  "keyboard_shortcuts.open_media": "Åpne media",
  "keyboard_shortcuts.pinned": "Åpne listen over festede innlegg",
  "keyboard_shortcuts.profile": "Åpne forfatterens profil",
  "keyboard_shortcuts.reply": "Svar på innlegg",
  "keyboard_shortcuts.requests": "Åpne listen over følgeforespørsler",
  "keyboard_shortcuts.search": "Gå til søkefeltet",
  "keyboard_shortcuts.spoilers": "Vis/skjul CW-felt",
  "keyboard_shortcuts.start": "Åpne kolonnen «Kom i gang»",
  "keyboard_shortcuts.toggle_hidden": "Vis/skjul tekst bak innholdsvarsel",
  "keyboard_shortcuts.toggle_sensitivity": "Vis/skjul media",
  "keyboard_shortcuts.toot": "Start et nytt innlegg",
  "keyboard_shortcuts.translate": "for å oversette et innlegg",
  "keyboard_shortcuts.unfocus": "Fjern fokus fra komponerings-/søkefeltet",
  "keyboard_shortcuts.up": "Flytt oppover i listen",
  "lightbox.close": "Lukk",
  "lightbox.next": "Neste",
  "lightbox.previous": "Forrige",
  "lightbox.zoom_in": "Zoom til original størrelse",
  "lightbox.zoom_out": "Vis hele",
  "limited_account_hint.action": "Vis profil likevel",
  "limited_account_hint.title": "Denne profilen har blitt skjult av moderatorene til {domain}.",
  "link_preview.author": "Av {name}",
  "link_preview.more_from_author": "Mer fra {name}",
  "link_preview.shares": "{count, plural, one {{counter} innlegg} other {{counter} innlegg}}",
  "lists.add_member": "Legg til",
  "lists.add_to_list": "Legg til i listen",
  "lists.add_to_lists": "Legg til {name} i liste",
  "lists.create": "Opprett",
  "lists.create_a_list_to_organize": "Lag en ny liste for å organisere hjemmetidslinjen",
  "lists.create_list": "Lag liste",
  "lists.delete": "Slett listen",
  "lists.done": "Ferdig",
  "lists.edit": "Rediger listen",
  "lists.exclusive": "Skjul medlemmer i Hjem",
  "lists.exclusive_hint": "Skjul innlegg fra folk i denne listen i Hjem-strømmen, så slipper du å se innleggene deres to ganger.",
  "lists.find_users_to_add": "Fin brukere å legge til",
  "lists.list_members_count": "{count, plural, one {# medlem} other {# medlemmer}}",
  "lists.list_name": "Listenavn",
  "lists.new_list_name": "Nytt listenavn",
  "lists.no_lists_yet": "Ingen lister ennå.",
  "lists.no_members_yet": "Ingen medlemmer ennå.",
  "lists.no_results_found": "Ingen treff.",
  "lists.remove_member": "Fjern",
  "lists.replies_policy.followed": "Enhver fulgt bruker",
  "lists.replies_policy.list": "Medlemmer i listen",
  "lists.replies_policy.none": "Ingen",
  "lists.save": "Lagre",
  "lists.search": "Søk",
  "lists.show_replies_to": "Inkluder svar fra listemedlemmer til",
  "load_pending": "{count, plural,one {# ny gjenstand} other {# nye gjenstander}}",
  "loading_indicator.label": "Laster…",
  "media_gallery.hide": "Skjul",
  "moved_to_account_banner.text": "Din konto {disabledAccount} er for øyeblikket deaktivert fordi du flyttet til {movedToAccount}.",
  "mute_modal.hide_from_notifications": "Ikke varsle",
  "mute_modal.hide_options": "Skjul alternativer",
  "mute_modal.indefinite": "Til jeg opphever dempingen",
  "mute_modal.show_options": "Vis alternativer",
  "mute_modal.they_can_mention_and_follow": "De kan nevne og følge deg, men du kommer ikke til å se dem.",
  "mute_modal.they_wont_know": "De kommer ikke til å få vite at du har valgt å skjule dem.",
  "mute_modal.title": "Demp bruker?",
  "mute_modal.you_wont_see_mentions": "Du kommer ikke til å se innlegg som nevner dem.",
  "mute_modal.you_wont_see_posts": "De kan fremdeles se dine innlegg, men du kommer ikke til å se deres.",
  "navigation_bar.about": "Om",
  "navigation_bar.account_settings": "Passord og sikkerhet",
  "navigation_bar.administration": "Administrasjon",
  "navigation_bar.advanced_interface": "Åpne i det avanserte nettgrensesnittet",
  "navigation_bar.automated_deletion": "Automatisert sletting av innlegg",
  "navigation_bar.blocks": "Blokkerte brukere",
  "navigation_bar.bookmarks": "Bokmerker",
  "navigation_bar.direct": "Private omtaler",
  "navigation_bar.domain_blocks": "Skjulte domener",
  "navigation_bar.favourites": "Favoritter",
  "navigation_bar.filters": "Stilnede ord",
  "navigation_bar.follow_requests": "Følgeforespørsler",
  "navigation_bar.followed_tags": "Fulgte emneknagger",
  "navigation_bar.follows_and_followers": "Følginger og følgere",
  "navigation_bar.import_export": "Importer og eksporter",
  "navigation_bar.lists": "Lister",
  "navigation_bar.logout": "Logg ut",
  "navigation_bar.moderation": "Moderering",
  "navigation_bar.more": "Mer",
  "navigation_bar.mutes": "Dempede brukere",
  "navigation_bar.opened_in_classic_interface": "Innlegg, kontoer og andre spesifikke sider åpnes som standard i det klassiske webgrensesnittet.",
  "navigation_bar.preferences": "Innstillinger",
  "navigation_bar.privacy_and_reach": "Personvern og rekkevidde",
  "navigation_bar.search": "Søk",
  "navigation_panel.collapse_lists": "Skjul listemeny",
  "navigation_panel.expand_lists": "Utvid listemeny",
  "not_signed_in_indicator.not_signed_in": "Du må logge inn for å få tilgang til denne ressursen.",
  "notification.admin.report": "{name} rapporterte {target}",
  "notification.admin.report_account": "{name} rapporterte {count, plural, one {et innlegg} other {# innlegg}} fra {target} for {category}",
  "notification.admin.report_account_other": "{name} rapporterte {count, plural, one {et innlegg} other {# innlegg}} fra {target}",
  "notification.admin.report_statuses": "{name} rapporterte {target} for {category}",
  "notification.admin.report_statuses_other": "{name} rapporterte {target}",
  "notification.admin.sign_up": "{name} registrerte seg",
  "notification.annual_report.message": "Din {year} #Wrapstodon venter på deg! Avgjør årets høydepunkter og minneverdige øyeblikk på Mastodon!",
  "notification.annual_report.view": "Se #Wrapstodon",
  "notification.favourite": "{name} favorittmarkerte innlegget ditt",
  "notification.favourite.name_and_others_with_link": "{name} og <a>{count, plural, one {# andre} other {# andre}}</a> markerte innlegget ditt som favoritt",
  "notification.favourite_pm": "{name} markerte din private omtale som favoritt",
  "notification.favourite_pm.name_and_others_with_link": "{name} og <a>{count, plural, one {# andre} other {# andre}}</a> markerte din private omtale som favoritt",
  "notification.follow": "{name} fulgte deg",
  "notification.follow_request": "{name} har bedt om å få følge deg",
  "notification.label.mention": "Nevn",
  "notification.label.private_mention": "Private omtaler",
  "notification.label.private_reply": "Private svar",
  "notification.label.reply": "Svar",
  "notification.mention": "Nevn",
  "notification.mentioned_you": "{name} nevnte deg",
  "notification.moderation-warning.learn_more": "Lær mer",
  "notification.moderation_warning": "Du har fått en advarsel fra en moderator",
  "notification.moderation_warning.action_delete_statuses": "Noen av innleggene dine har blitt fjernet.",
  "notification.moderation_warning.action_disable": "Kontoen din har blitt deaktivert.",
  "notification.moderation_warning.action_mark_statuses_as_sensitive": "Noen av innleggene dine har blitt markert som sensitive.",
  "notification.moderation_warning.action_none": "Kontoen din har fått en advarsel fra en moderator.",
  "notification.moderation_warning.action_sensitive": "Dine innlegg vil fra nå av bli markert som sensitive.",
  "notification.moderation_warning.action_silence": "Kontoen din har blitt begrenset.",
  "notification.moderation_warning.action_suspend": "Kontoen din har blitt utestengt.",
  "notification.own_poll": "Avstemningen din er ferdig",
  "notification.poll": "En avstemning du stemte på er avsluttet",
  "notification.reblog": "{name} fremhevet ditt innlegg",
  "notification.reblog.name_and_others_with_link": "{name} og <a>{count, plural, one {# andre} other {# andre}}</a> framhevet innlegget ditt",
  "notification.relationships_severance_event": "Mistet kontakten med {name}",
  "notification.relationships_severance_event.account_suspension": "En administrator fra {from} har suspendert {target}, som betyr at du ikke lenger kan motta oppdateringer fra dem eller kommunisere med dem.",
  "notification.relationships_severance_event.domain_block": "En administrator fra {from} har blokkert {target}, inkludert {followersCount} av dine følgere og {followingCount, plural, one {# konto} other {# kontoer}} du følger.",
  "notification.relationships_severance_event.learn_more": "Lær mer",
  "notification.relationships_severance_event.user_domain_block": "Du har blokkert {target} og fjernet {followersCount} av følgerne dine og {followingCount, plural, one {# konto} other {# kontoer}} du følger.",
  "notification.status": "{name} la nettopp ut",
  "notification.update": "{name} redigerte et innlegg",
  "notification_requests.accept": "Aksepter",
  "notification_requests.accept_multiple": "{count, plural, one {Aksepter # forespørsel…} other {Aksepter # forespørsler…}}",
  "notification_requests.confirm_accept_multiple.button": "{count, plural, one {Aksepter forespørsel} other {Aksepter forespørsler}}",
  "notification_requests.confirm_accept_multiple.title": "Godta varslingsforespørsler?",
  "notification_requests.dismiss": "Lukk",
  "notification_requests.edit_selection": "Redigér",
  "notification_requests.exit_selection": "Ferdig",
  "notification_requests.explainer_for_limited_remote_account": "Varsler fra denne kontoen har blitt filtrert bort fordi kontoen eller serveren den er på har blitt sensurert av en moderator.",
  "notification_requests.maximize": "Maksimer",
  "notification_requests.minimize_banner": "Minimer banneret for filtrerte varsler",
  "notification_requests.notifications_from": "Varsler fra {name}",
  "notification_requests.title": "Filtrerte varlser",
  "notification_requests.view": "Vis varsler",
  "notifications.clear": "Fjern varsler",
  "notifications.clear_confirmation": "Er du sikker på at du vil fjerne alle dine varsler permanent?",
  "notifications.clear_title": "Fjern varsler?",
  "notifications.column_settings.admin.report": "Nye rapporter:",
  "notifications.column_settings.admin.sign_up": "Nye registreringer:",
  "notifications.column_settings.alert": "Skrivebordsvarslinger",
  "notifications.column_settings.favourite": "Favoritter:",
  "notifications.column_settings.filter_bar.advanced": "Vis alle kategorier",
  "notifications.column_settings.filter_bar.category": "Hurtigfiltreringslinje",
  "notifications.column_settings.follow": "Nye følgere:",
  "notifications.column_settings.follow_request": "Nye følgerforespørsler:",
  "notifications.column_settings.group": "Gruppe",
  "notifications.column_settings.mention": "Nevnt:",
  "notifications.column_settings.poll": "Avstemningsresultater:",
  "notifications.column_settings.push": "Push varsler",
  "notifications.column_settings.reblog": "Fremhevet:",
  "notifications.column_settings.show": "Vis i kolonne",
  "notifications.column_settings.sound": "Spill lyd",
  "notifications.column_settings.status": "Nye innlegg:",
  "notifications.column_settings.unread_notifications.category": "Uleste varslinger",
  "notifications.column_settings.unread_notifications.highlight": "Marker uleste varslinger",
  "notifications.column_settings.update": "Redigeringer:",
  "notifications.filter.all": "Alle",
  "notifications.filter.boosts": "Fremhevinger",
  "notifications.filter.favourites": "Favoritter",
  "notifications.filter.follows": "Følginger",
  "notifications.filter.mentions": "Nevnelser",
  "notifications.filter.polls": "Avstemningsresultater",
  "notifications.filter.statuses": "Oppdateringer fra folk du følger",
  "notifications.grant_permission": "Gi tillatelse.",
  "notifications.group": "{count} varslinger",
  "notifications.mark_as_read": "Merk alle varsler som lest",
  "notifications.permission_denied": "Skrivebordsvarsler er ikke tilgjengelige på grunn av tidligere nektet nettlesertillatelser",
  "notifications.permission_denied_alert": "Skrivebordsvarsler kan ikke aktiveres, ettersom lesertillatelse har blitt nektet før",
  "notifications.permission_required": "Skrivebordsvarsler er utilgjengelige fordi nødvendige rettigheter ikke er gitt.",
  "notifications.policy.accept": "Godta",
  "notifications.policy.accept_hint": "Vis i varsler",
  "notifications.policy.drop": "Overse",
  "notifications.policy.drop_hint": "Send til avgrunnen, for aldri å bli sett igjen",
  "notifications.policy.filter": "Filter",
  "notifications.policy.filter_hint": "Send til filtrert varslingsinnboks",
  "notifications.policy.filter_limited_accounts_hint": "Begrenset av serverens moderatorer",
  "notifications.policy.filter_limited_accounts_title": "Modererte kontoer",
  "notifications.policy.filter_new_accounts.hint": "Opprettet {days, plural, one {den siste dagen} other {i de siste # dagene}}",
  "notifications.policy.filter_new_accounts_title": "Nye kontoer",
  "notifications.policy.filter_not_followers_hint": "Inkludert personer som har fulgt deg mindre enn {days, plural, one {en dag} other {# dager}}",
  "notifications.policy.filter_not_followers_title": "Personer som ikke følger deg",
  "notifications.policy.filter_not_following_hint": "Inntil du manuelt godkjenner dem",
  "notifications.policy.filter_not_following_title": "Personer du ikke følger",
  "notifications.policy.filter_private_mentions_hint": "Filtrert med mindre det er et svar som omtaler deg, eller hvis du følger avsenderen",
  "notifications.policy.filter_private_mentions_title": "Uoppfordrede private omtaler",
  "notifications.policy.title": "Behandle varsler fra…",
  "notifications_permission_banner.enable": "Skru på skrivebordsvarsler",
  "notifications_permission_banner.how_to_control": "For å motta varsler når Mastodon ikke er åpne, aktiver desktop varsler. Du kan kontrollere nøyaktig hvilke typer interaksjoner genererer skrivebordsvarsler gjennom {icon} -knappen ovenfor når de er aktivert.",
  "notifications_permission_banner.title": "Aldri gå glipp av noe",
  "onboarding.follows.back": "Tilbake",
  "onboarding.follows.empty": "Dessverre kan ingen resultater vises akkurat nå. Du kan prøve å bruke søk eller bla gjennom utforske-siden for å finne folk å følge, eller prøve igjen senere.",
  "onboarding.follows.search": "Søk",
  "onboarding.follows.title": "Følg folk for å komme i gang",
  "onboarding.profile.discoverable": "Gjør min profil synlig",
  "onboarding.profile.display_name": "Visningsnavn",
  "onboarding.profile.display_name_hint": "Ditt fulle navn eller ditt morsomme navn…",
  "onboarding.profile.note": "Om meg",
  "onboarding.profile.note_hint": "Du kan @nevne andre eller #emneknagger…",
  "onboarding.profile.title": "Konfigurering av profil",
  "onboarding.profile.upload_avatar": "Last opp profilbilde",
  "onboarding.profile.upload_header": "Last opp profiltoppbilde",
  "password_confirmation.exceeds_maxlength": "Passordbekreftelsen overskrider den maksimale passordlengden",
  "password_confirmation.mismatching": "Passordene er ulike",
  "picture_in_picture.restore": "Legg den tilbake",
  "poll.closed": "Lukket",
  "poll.refresh": "Oppdater",
  "poll.reveal": "Vis resultater",
  "poll.total_people": "{count, plural, one {# person} other {# personer}}",
  "poll.total_votes": "{count, plural, one {# stemme} other {# stemmer}}",
  "poll.vote": "Stem",
  "poll.voted": "Du stemte på dette svaret",
  "poll.votes": "{votes, plural, one {# stemme} other {# stemmer}}",
  "poll_button.add_poll": "Legg til en avstemning",
  "poll_button.remove_poll": "Fjern avstemningen",
  "privacy.change": "Juster synlighet",
  "privacy.direct.long": "Alle nevnt i innlegget",
  "privacy.private.long": "Bare følgerne dine",
  "privacy.private.short": "Følgere",
  "privacy.public.long": "Alle på og utenfor Mastodon",
  "privacy.public.short": "Offentlig",
  "privacy.unlisted.short": "Stille offentlig",
  "privacy_policy.last_updated": "Sist oppdatert {date}",
  "privacy_policy.title": "Personvernregler",
  "recommended": "Anbefalt",
  "refresh": "Oppfrisk",
  "relative_time.days": "{number}d",
  "relative_time.full.days": "{number, plural, one {# dag} other {# dager}} siden",
  "relative_time.full.hours": "{number, plural, one {# time} other {# timer}} siden",
  "relative_time.full.just_now": "nettopp",
  "relative_time.full.minutes": "for {number, plural, one {# minutt} other {# minutter}} siden",
  "relative_time.full.seconds": "for {number, plural, one {# sekund} other {# sekunder}} siden",
  "relative_time.hours": "{number}t",
  "relative_time.just_now": "nå",
  "relative_time.minutes": "{number}m",
  "relative_time.seconds": "{number}s",
  "relative_time.today": "i dag",
  "reply_indicator.attachments": "{count, plural, one {# vedlegg} other {# vedlegg}}",
  "reply_indicator.cancel": "Avbryt",
  "reply_indicator.poll": "Avstemming",
  "report.block": "Blokker",
  "report.block_explanation": "Du kommer ikke til å se innleggene deres. De vil ikke kunne se innleggene dine eller følge deg. De vil kunne se at de er blokkert.",
  "report.categories.legal": "Juridisk",
  "report.categories.other": "Annet",
  "report.categories.spam": "Søppelpost",
  "report.categories.violation": "Innholdet bryter en eller flere serverregler",
  "report.category.subtitle": "Velg det som passer best",
  "report.category.title": "Fortell oss hva som skjer med denne {type}",
  "report.category.title_account": "profil",
  "report.category.title_status": "innlegg",
  "report.close": "Utført",
  "report.comment.title": "Er det noe annet du mener vi burde vite?",
  "report.forward": "Videresend til {target}",
  "report.forward_hint": "Denne kontoen er fra en annen tjener. Vil du sende en anonymisert kopi av rapporten dit også?",
  "report.mute": "Demp",
  "report.mute_explanation": "Du kommer ikke til å se deres innlegg. De kan fortsatt følge deg og se dine innlegg, og kan ikke se at de er dempet.",
  "report.next": "Neste",
  "report.placeholder": "Tilleggskommentarer",
  "report.reasons.dislike": "Jeg liker det ikke",
  "report.reasons.dislike_description": "Det er ikke noe du har lyst til å se",
  "report.reasons.legal": "Det er ulovlig",
  "report.reasons.legal_description": "Du mener det bryter loven i ditt eller serverens land",
  "report.reasons.other": "Det er noe annet",
  "report.reasons.other_description": "Problemet passer ikke inn i de andre kategoriene",
  "report.reasons.spam": "Det er spam",
  "report.reasons.spam_description": "Ondsinnede lenker, falsk engasjement eller repeterende svar",
  "report.reasons.violation": "Det bryter serverregler",
  "report.reasons.violation_description": "Du er klar over at det bryter spesifikke regler",
  "report.rules.subtitle": "Velg alle som passer",
  "report.rules.title": "Hvilke regler brytes?",
  "report.statuses.subtitle": "Velg alle som passer",
  "report.statuses.title": "Er det noen innlegg som støtter opp under denne rapporten?",
  "report.submit": "Send inn",
  "report.target": "Rapporterer",
  "report.thanks.take_action": "Her er alternativene dine for å kontrollere hva du ser på Mastodon:",
  "report.thanks.take_action_actionable": "Mens vi går gjennom dette, kan du iverksettet tiltak mot @{name}:",
  "report.thanks.title": "Ønsker du ikke å se dette?",
  "report.thanks.title_actionable": "Takk for at du rapporterer, vi skal se på dette.",
  "report.unfollow": "Slutt å følge @{name}",
  "report.unfollow_explanation": "Du følger denne kontoen. For ikke å se innleggene deres i din tidslinje lenger, slutt å følge dem.",
  "report_notification.attached_statuses": "{count, plural,one {{count} innlegg} other {{count} innlegg}} vedlagt",
  "report_notification.categories.legal": "Juridiske",
  "report_notification.categories.legal_sentence": "ulovlig innhold",
  "report_notification.categories.other": "Annet",
  "report_notification.categories.other_sentence": "annet",
  "report_notification.categories.spam": "Søppelpost",
  "report_notification.categories.spam_sentence": "spam",
  "report_notification.categories.violation": "Regelbrudd",
  "report_notification.categories.violation_sentence": "regel brudd",
  "report_notification.open": "Åpne rapport",
  "search.clear": "Tøm søk",
  "search.no_recent_searches": "Ingen søk nylig",
  "search.placeholder": "Søk",
  "search.quick_action.account_search": "Profiler som samsvarer med {x}",
  "search.quick_action.go_to_account": "Gå til profil {x}",
  "search.quick_action.go_to_hashtag": "Gå til emneknagg {x}",
  "search.quick_action.open_url": "Åpne URL i Mastodon",
  "search.quick_action.status_search": "Innlegg som samsvarer med {x}",
  "search.search_or_paste": "Søk eller lim inn URL",
  "search_popout.full_text_search_disabled_message": "Ikke tilgjengelig på {domain}.",
  "search_popout.full_text_search_logged_out_message": "Bare tilgjengelig når man er logget inn.",
  "search_popout.language_code": "ISO språkkode",
  "search_popout.options": "Alternativer for søk",
  "search_popout.quick_actions": "Hurtighandlinger",
  "search_popout.recent": "Nylige søk",
  "search_popout.specific_date": "bestemt dato",
  "search_popout.user": "bruker",
  "search_results.accounts": "Profiler",
  "search_results.all": "Alle",
  "search_results.hashtags": "Emneknagger",
  "search_results.no_results": "Ingen resultater.",
  "search_results.no_search_yet": "Søk etter innlegg, profiler eller hashtags.",
  "search_results.see_all": "Se alle",
  "search_results.statuses": "Innlegg",
  "search_results.title": "Søk etter \"{q}\"",
  "server_banner.about_active_users": "Personer som har brukt denne serveren i løpet av de siste 30 dagene (aktive brukere månedlig)",
  "server_banner.active_users": "aktive brukere",
  "server_banner.administered_by": "Administrert av:",
  "server_banner.is_one_of_many": "{domain} er en av mange uavhengige Mastodon-servere du kan bruke for å delta i det desentraliserte sosiale nettet.",
  "server_banner.server_stats": "Serverstatistikk:",
  "sign_in_banner.create_account": "Opprett konto",
  "sign_in_banner.follow_anyone": "Følg hvem som helst på tvers av det desentraliserte sosiale nettet. Ingen algoritmer, reklamer eller clickbait.",
  "sign_in_banner.sign_in": "Logg inn",
  "sign_in_banner.sso_redirect": "Logg inn eller registrer deg",
  "status.admin_account": "Åpne moderatorgrensesnittet for @{name}",
  "status.admin_domain": "Åpne moderatorgrensesnittet for {domain}",
  "status.admin_status": "Åpne dette innlegget i moderatorgrensesnittet",
  "status.all_disabled": "Fremheving og sitering er deaktivert",
  "status.block": "Blokker @{name}",
  "status.bookmark": "Bokmerke",
  "status.cancel_reblog_private": "Fjern fremheving",
  "status.cannot_quote": "Du har ikke tilgang til å sitere dette innlegget",
  "status.cannot_reblog": "Denne posten kan ikke fremheves",
  "status.contains_quote": "Inneholder sitat",
  "status.context.loading": "Laster inn flere svar",
  "status.context.loading_error": "Klarte ikke å laste inn nye svar",
  "status.context.loading_success": "Nye svar er lastet inn",
  "status.context.more_replies_found": "Flere svar funnet",
  "status.context.retry": "Prøv igjen",
  "status.context.show": "Vis",
  "status.continued_thread": "Fortsettelse av samtale",
  "status.copy": "Kopier lenken til innlegget",
  "status.delete": "Slett",
  "status.delete.success": "Innlegget er slettet",
  "status.detailed_status": "Detaljert samtalevisning",
  "status.direct": "Nevn @{name} privat",
  "status.direct_indicator": "Privat omtale",
  "status.edit": "Rediger",
  "status.edited": "Sist endret {date}",
  "status.edited_x_times": "Redigert {count, plural,one {{count} gang} other {{count} ganger}}",
  "status.favourite": "Favoritt",
  "status.filter": "Filtrer dette innlegget",
  "status.history.created": "{name} opprettet {date}",
  "status.history.edited": "{name} redigerte {date}",
  "status.load_more": "Last mer",
  "status.media.open": "Klikk for å åpne",
  "status.media.show": "Klikk for å vise",
  "status.media_hidden": "Media skjult",
  "status.mention": "Nevn @{name}",
  "status.more": "Mer",
  "status.mute": "Demp @{name}",
  "status.mute_conversation": "Demp samtale",
  "status.open": "Utvid dette innlegget",
  "status.pin": "Fest på profilen",
  "status.quote_error.blocked_account_hint.title": "Dette innlegget er skjult fordi du har blokkert @{name}.",
  "status.quote_error.blocked_domain_hint.title": "Dette innlegget er skjult fordi du har blokkert {domain}.",
  "status.quote_error.filtered": "Skjult på grunn av et av filterne dine",
  "status.quote_error.limited_account_hint.action": "Vis likevel",
  "status.quote_error.limited_account_hint.title": "Denne kontoen har blitt skjult av moderatorene til {domain}.",
  "status.quote_error.muted_account_hint.title": "Dette innlegget er skjult fordi du har dempet @{name}.",
  "status.quote_error.not_available": "Innlegg utilgjengelig",
  "status.quote_error.pending_approval": "Ventende innlegg",
  "status.read_more": "Les mer",
  "status.reblog": "Fremhev",
  "status.reblogged_by": "Fremhevet av {name}",
  "status.reblogs.empty": "Ingen har fremhevet dette innlegget enda. Når noen gjør det, vil de dukke opp her.",
  "status.redraft": "Slett og skriv på nytt",
  "status.remove_bookmark": "Fjern bokmerke",
  "status.remove_favourite": "Fjern fra favoritter",
  "status.remove_quote": "Fjern",
  "status.replied_in_thread": "Svarte i tråd",
  "status.replied_to": "Som svar til {name}",
  "status.reply": "Svar",
  "status.replyAll": "Svar til samtale",
  "status.report": "Rapporter @{name}",
  "status.request_quote": "Send forespørsel om å sitere",
  "status.revoke_quote": "Fjern innlegget mitt fra @{name}' innlegg",
  "status.sensitive_warning": "Følsomt innhold",
  "status.share": "Del",
  "status.show_less_all": "Vis mindre for alle",
  "status.show_more_all": "Vis mer for alle",
  "status.show_original": "Vis original",
  "status.title.with_attachments": "{user} postet {attachmentCount, plural, one {et vedlegg} other {{attachmentCount} vedlegg}}",
  "status.translate": "Oversett",
  "status.translated_from_with": "Oversatt fra {lang} ved å bruke {provider}",
  "status.uncached_media_warning": "Forhåndsvisning er ikke tilgjengelig",
  "status.unmute_conversation": "Ikke demp samtale",
  "status.unpin": "Angre festing på profilen",
  "subscribed_languages.lead": "Bare innlegg på valgte språk vil dukke opp i dine hjem- og liste-tidslinjer etter endringen. Velg ingen for å motta innlegg på alle språk.",
  "subscribed_languages.save": "Lagre endringer",
  "subscribed_languages.target": "Endre abonnerte språk for {target}",
  "tabs_bar.home": "Hjem",
  "tabs_bar.menu": "Meny",
  "tabs_bar.notifications": "Varslinger",
  "tabs_bar.publish": "Nytt Innlegg",
  "tabs_bar.search": "Søk",
  "tag.remove": "Fjern",
  "terms_of_service.title": "Bruksvilkår",
  "terms_of_service.upcoming_changes_on": "Kommende endringer på {date}",
  "time_remaining.days": "{number, plural,one {# dag} other {# dager}} igjen",
  "time_remaining.hours": "{number, plural, one {# time} other {# timer}} igjen",
  "time_remaining.minutes": "{number, plural, one {# minutt} other {# minutter}} igjen",
  "time_remaining.moments": "Gjenværende øyeblikk",
  "time_remaining.seconds": "{number, plural, one {# sekund} other {# sekunder}} igjen",
  "trends.counter_by_accounts": "{count, plural, one {{counter} person} other {{counter} folk}} {days, plural, one {den siste dagen} other {de siste {days} dagene}}",
  "trends.trending_now": "Trender nå",
  "ui.beforeunload": "Din kladd vil bli forkastet om du forlater Mastodon.",
  "units.short.billion": "{count}m.ard",
  "units.short.million": "{count}mill",
  "units.short.thousand": "{count}k",
  "upload_area.title": "Dra og slipp for å laste opp",
  "upload_button.label": "Legg til media",
  "upload_error.limit": "Filopplastingsgrensen er oversteget.",
  "upload_error.poll": "Filopplasting er ikke tillatt for avstemninger.",
  "upload_error.quote": "Filopplasting er ikke tillatt med sitat.",
  "upload_form.drag_and_drop.instructions": "For å plukke opp et medievedlegg, trykk på mellomrom eller enter. Bruk piltastene for å flytte medievedlegget i ønsket retning. Trykk mellomrom eller enter igjen for å slippe vedlegget på nytt sted, eller trykk på esc for å avbryte.",
  "upload_form.edit": "Rediger",
  "upload_progress.label": "Laster opp...",
  "upload_progress.processing": "Behandler…",
  "username.taken": "Dette brukernavnet er tatt. Prøv et annet",
  "video.close": "Lukk video",
  "video.download": "Last ned fil",
  "video.exit_fullscreen": "Lukk fullskjerm",
  "video.expand": "Utvid video",
  "video.fullscreen": "Fullskjerm",
  "video.hide": "Skjul video",
  "video.pause": "Pause",
  "video.play": "Spill av"
}
